module.exports = __webpack_public_path__ + "static/media/b1_p1_boomer.40399152.mp3";